/*
 * @LastEditTime: 2025-02-26 15:36:54
 */
import { buildProps, numericProp, unknownProp } from '@xzx-design/utils'
import { UPDATE_MODEL_EVENT } from '@xzx-design/constants'

import type { ExtractPropTypes } from 'vue'
import type RadioGroup from './radio-group.tsx'
import type { PropType } from 'vue/dist/vue'
import type { RadioGroupDirection, RadioShape } from './types'

export const radioGroupProps = buildProps({
  modelValue: {
    type: unknownProp,
  },
  shape: {
    type: String as PropType<RadioShape>,
  },
  disabled: Boolean,
  iconSize: {
    type: numericProp,
  },
  direction: {
    type: String as PropType<RadioGroupDirection>,
  },
  checkedColor: String,
})

export const radioGroupEmits = {
  [UPDATE_MODEL_EVENT]: (value: unknown) => value,
  change: (event: unknown) => event,
}

export type RadioGroupProps = ExtractPropTypes<typeof radioGroupProps>
export type RadioGroupInstance = InstanceType<typeof RadioGroup>
export type RadioGroupEmits = typeof radioGroupEmits
